import clsx from 'clsx';
import * as d3 from 'd3';
import { ScaleLinear } from 'd3';
import React, { memo } from 'react';

import { PlotLine, PlotTypes } from '../../HighLowTripleLineChart.types';
import { GradientArea } from '../gradient-area/GradientArea';
import { LinePlot } from '../line-plot/LinePlot';
import styles from './Plot.module.scss';

export interface PlotProps {
  plots: PlotLine[];
  xScale: ScaleLinear<number, number>;
  yScale: ScaleLinear<number, number>;
  linePlotType?: PlotTypes;
}

const Plot = ({ plots, xScale, yScale, linePlotType }: PlotProps) => {
  return (
    <>
      {plots.map(({ type, ts, gradients }) =>
        gradients?.map(({ y0, y1, gradientStops }) => (
          <GradientArea
            key={`plot-${type}-gradient-${y0}`}
            ts={ts}
            scaleX={xScale}
            scaleY={yScale}
            stops={gradientStops}
            y1={y1}
            y0={y0}
            curve={d3.curveLinear}
          />
        ))
      )}
      {plots.map(({ type, ts }) => (
        <LinePlot
          key={`plot-line-${type}`}
          className={clsx({
            [styles.typePositive]:
              (linePlotType ?? PlotTypes.Positive) === PlotTypes.Positive,
            [styles.typeNegative]:
              (linePlotType ?? PlotTypes.Positive) === PlotTypes.Negative,
            [styles.typeMedian]:
              (linePlotType ?? PlotTypes.Positive) === PlotTypes.Median,
            [styles.dashed]: type === PlotTypes.Median,
          })}
          ts={ts}
          scaleX={xScale}
          scaleY={yScale}
          curve={d3.curveLinear}
        />
      ))}
    </>
  );
};

export const MemoPlot = memo(Plot);
